import { render, staticRenderFns } from "./instanceManage.vue?vue&type=template&id=fa583462&"
import script from "./instanceManage.vue?vue&type=script&lang=js&"
export * from "./instanceManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports